import currencies from 'constants/currencies';

import trialOfferGWPMixedWithSkincareMinisModalContent from 'assets/content/promotions/trialOfferGWPMixedWithSkincareMinisModal';
import image60Percent from 'assets/images/promotions/trial-offer-claw-clipper-gwp-promotion-hc-sc-sss-modal-60.jpg';

const popUpConditions = (
  <>
    See the full promotion terms and conditions{' '}
    <a
      data-click="return-policy"
      data-from="trial-offer-v2-hc-sc-pop-up"
      href="https://prose.com/faq/5ee3386a083d64001a9ffc68"
      target="_blank"
    >
      here
    </a>
    .
  </>
);

const bottomModalDescription = (
  <>
    Try Prose with <b>60% off + a FREE gift</b>, or a <b>complimentary Skincare Starter Set</b> when
    you subscribe to 3+ products.
  </>
);

const bottomModalConditions = (
  <>
    See the full promotion terms and conditions{' '}
    <a href="https://prose.com/faq/5ee3386a083d64001a9ffc68" target="_blank">
      here
    </a>
    .
  </>
);

const content = {
  banner: 'Get 60% off haircare + free gift, or try skincare on Prose',
  popUpModal: {
    [currencies.USD]: {
      ...trialOfferGWPMixedWithSkincareMinisModalContent.popUpModal[currencies.USD],
      image: image60Percent,
      headerTitle: 'EXCLUSIVE WELCOME OFFER',
      conditions: popUpConditions,
    },
    [currencies.CAD]: {
      ...trialOfferGWPMixedWithSkincareMinisModalContent.popUpModal[currencies.CAD],
      image: image60Percent,
      headerTitle: 'EXCLUSIVE WELCOME OFFER',
      conditions: popUpConditions,
    },
  },
  bottomModal: {
    [currencies.USD]: {
      ...trialOfferGWPMixedWithSkincareMinisModalContent.bottomModal[currencies.USD],
      title: 'EXCLUSIVE WELCOME OFFER',
      description: bottomModalDescription,
      conditions: bottomModalConditions,
    },
    [currencies.CAD]: {
      ...trialOfferGWPMixedWithSkincareMinisModalContent.bottomModal[currencies.CAD],
      title: 'EXCLUSIVE WELCOME OFFER',
      description: bottomModalDescription,
      conditions: bottomModalConditions,
    },
  },
};

export default content;
